import logger from '../../../utils/logger-instance'
import {getStaticHost} from '../../../utils/site-utils'

let loadingPromise = null

const loadCmsScripts = ({site, locale, nonce, signal}) => {
    if (loadingPromise) {
        logger.debug('CMS scripts are already loading, returning existing promise')
        return loadingPromise
    }
    loadingPromise = loadCmsScriptsInternal({site, locale, nonce, signal})
    // clean up the promise only on rejection to retry on next call,
    // otherwise keep it forever
    loadingPromise.catch((reason) => {
        loadingPromise = null
        return Promise.reject(reason)
    })
    return loadingPromise
}

const loadCmsScriptsInternal = ({site, locale, nonce, signal}) =>
    new Promise((resolve, reject) => {
        const staticHost = getStaticHost()

        const src = `${staticHost}/on/demandware.static/Sites-${site.alias || site.id}-Site/-/${
            locale.alias || locale.id
        }/js/cms-script${process.env.NODE_ENV === 'production' ? '.min' : ''}.js`

        // Load the CMS scripts dynamically
        const script = document.createElement('script')
        script.async = true
        script.onload = () => {
            logger.debug(`CMS scripts loaded from ${src}`)
            resolve({
                // NOTE: these are the global variables that are exported by cms-script.min.js
                // if needed new variables can be added here
                extTns: window.extTns,
                cmsTools: window.cmsTools
            })
        }
        script.onerror = (error) => {
            logger.error(`Error loading CMS scripts from ${src}`, error)
            reject(new Error(`Failed to load CMS scripts from ${src}`))
        }
        script.onabort = () => {
            logger.warn(`Loading CMS scripts from ${src} aborted`)
            script.remove()
            // no need to raise an error here, just clean up
            return {}
        }
        if (nonce) {
            script.nonce = nonce
        }
        signal?.addEventListener('abort', () => {
            logger.warn(`Loading CMS scripts from ${src} aborted`)
            script.remove()
            // no need to raise an error here, just clean up
            return {}
        })
        script.src = src
        logger.debug(`Appending CMS scripts from ${src} to document head`)
        document.head.appendChild(script)
    })

export default loadCmsScripts
